<template>
  <div>
  </div>
</template>

<script>
  export default {
    name: "FromBuilder",
    created() {
      let query = this.$route.query;
      this.$store.commit('setAdmin', {
        email: query.email,
        username: query.username,
        token: query.tn,
        id: query.i,
        phone: query.phone,
        service: query.service,
        service_key: query.service_key,
        profile: query.profile
      });
      this.$store.commit('setServiceName', query.service);
      this.setAuthHeader();
      location.replace(`/office/admin/${query.path}?builder=true`);
    },
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style lang="stylus" scoped>

</style>
